import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import PageLayout from '../components/PageLayout';
import AnalyticsHub from '../components/AnalyticsHub';

const VenueViewsAnalyticsPage: React.FC = () => {
  const { token } = useAuth();

  return (
    <PageLayout title="Venue Views Analytics">
      <AnalyticsHub
        token={token}
        title="Venue"
        metricType="venue"
        blurb="Venue engagement popularity from the nightly analytics rollup (venue_view, ticket_click, share_open). Use the links below for GA4, CloudWatch, and Athena deep history."
      />
    </PageLayout>
  );
};

export default VenueViewsAnalyticsPage;
